// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ns-5";
export var filledCircle = "_ns-4";
export var historyEntry = "_ns-3";
export var messageSideLeft = "_ns-1";
export var messageSideRight = "_ns-2";
export var orderTrackingCarouselWrapper = "_ns-6";
export var orderTrackingInfoContainer = "_ns-0";